import React from 'react'
import style from './style.module.less'
export default ({
  store: {
    stepTwoStore: { anchor, changeAnchor }
  }
}) => {
  return (
    <div className={style.titlewarp}>
      <div className={style.title}>
        {anchor.map(({ active, key, text }, index) => {
          return (
            <div
              className={`${active ? style.active : style.common}`}
              // style={{
              //   borderLeft: key === 2 ? '1px solid #CCCCCC' : 'none',
              //   borderRight: key === 2 ? '1px solid #CCCCCC' : 'none'
              // }}
              key={key}
              onClick={() => changeAnchor(index + 1)}
            >
              {text}
            </div>
          )
        })}
      </div>
    </div>
  )
}
